// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bdce4122","283":"f352c7c6","793":"af528ea9"}[chunkId] + ".chunk.js";
};